import React from 'react';
import PropTypes from 'prop-types';
import { object, string, mixed } from 'yup';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Button, Form } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAttachment } from '~/utils/attachment';

import Fields from './Fields';

const validationSchema = object().shape({
  docType: string().required(),
  title: string().max('150').required(),
  description: string().max('255'),
  link: string().url().when('docType', {
    is: 'link',
    then: s => s.required(),
    otherwise: s => s.notRequired(),
  }),
  file: mixed().when('docType', {
    is: v => v !== 'link',
    then: s => s.required(),
    otherwise: s => s.notRequired(),
  }),
});

const initialValues = {
  title: '',
  link: '',
};

const DocForm = ({ data, disabled }) => {
  const history = useHistory();
  const { actions: { createAttachment } } = useAttachment();

  const handleSubmit = (v, b) => {
    createAttachment(v)
      .then(() => {
        toast.success('Successfully saved!');

        history.push(`/patients/${v.patient_id}/docs`);
      })
      .catch(e => {
        b.setErrors({
          server: e,
        });

        toast.error('Oops, something went wrong!');
      })
      .finally(() => b.setSubmitting(false));
  };

  return (
    <Form
      displayName="DocForm"
      validationSchema={validationSchema}

      initialValues={{
        ...initialValues,
        ...data,
      }}

      onSubmit={handleSubmit}
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody className="p-0">
            <Fields disabled={disabled} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="cancel"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>

              <Button type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

DocForm.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
};

DocForm.defaultProps = {
  data: {},
  disabled: false,
};

export default DocForm;
